import {
  QueryObserverResult,
  RefetchOptions,
  RefetchQueryFilters,
  useQuery,
} from '@tanstack/react-query';

import { HttpClientError } from '~/src/clients/http/HttpClient';

import { BILLING_CACHE_KEY } from '../constants/billingCacheKey';
import { BillingType, billingService } from '../services/BillingService';

export interface FetchBillingReturnType {
  data: BillingType | undefined;
  error: HttpClientError | null;
  refetch: <TPageData>(
    options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined,
  ) => Promise<QueryObserverResult<BillingType, HttpClientError>>;
  status: 'error' | 'loading' | 'success';
}

export const useFetchBilling = (): FetchBillingReturnType => {
  const { data, error, refetch, status } = useQuery<BillingType, HttpClientError>({
    queryFn: billingService.get,
    queryKey: [BILLING_CACHE_KEY],
  });

  return { data, error, refetch, status };
};
